var React = require('react');

function VideoPlayOverlay (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Play Video Icon"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-160.000000, -513.000000)"},React.createElement("g",{"transform":"translate(160.000000, 513.000000)"},[React.createElement("rect",{"id":"Circle","fill":"currentColor","opacity":"0.7","x":"0","y":"0","width":"55","height":"55","rx":"27.5","key":0}),React.createElement("polygon",{"id":"Triangle","fill":"#333333","transform":"translate(31.500000, 28.000000) rotate(-270.000000) translate(-31.500000, -28.000000) ","points":"31.5 16.5 45.5 39.5 17.5 39.5","key":1})])))]);
}

VideoPlayOverlay.defaultProps = {"viewBox":"0 0 55 55","version":"1.1"};

module.exports = VideoPlayOverlay;

VideoPlayOverlay.default = VideoPlayOverlay;
